import custom from "./markdown/custom";
import normal from "./markdown/normal";
import theme1 from './markdown/theme-1';
import theme3 from './markdown/theme-3';
import theme12 from './markdown/theme-12';
import theme17 from './markdown/theme-17';
import theme45 from './markdown/theme-45';
import theme51 from './markdown/theme-51'

import content from "./content.md";

import atomOneDark from "./code/atomOneDark";
import atomOneLight from "./code/atomOneLight";
import github from "./code/github";
import monokai from "./code/monokai";
import vs2015 from "./code/vs2015";
import xcode from "./code/xcode";

import macAtomOneDark from "./macCode/macAtomOneDark";
import macAtomOneLight from "./macCode/macAtomOneLight";
import macGithub from "./macCode/macGithub";
import macMonokai from "./macCode/macMonokai";
import macVs2015 from "./macCode/macVs2015";
import macXcode from "./macCode/macXcode";

import basic from "./basic";

let localThemeList = [
    {themeId: "theme1", name: "橙心", css: theme1},
    {themeId: "theme3", name: "姹紫", css: theme3},
    {themeId: "theme12", name: "前端之巅同款", css: theme12},
    {themeId: "theme17", name: "全栈蓝(主要)", css: theme17},
    {themeId: "theme45", name: "灵动蓝", css: theme45},
    {themeId: "theme51", name: "科技蓝", css: theme51},
]

export default {
  basic,
  normal,
  custom,
  localThemeList,
  code: {
    atomOneDark,
    atomOneLight,
    github,
    monokai,
    vs2015,
    xcode,
    macAtomOneDark,
    macAtomOneLight,
    macGithub,
    macMonokai,
    macVs2015,
    macXcode,
  },
  content,
};
